import { Account, PortfolioAssetType } from '../types';

const ACCOUNT_ASSET_TYPE: Partial<Record<Account['type'], PortfolioAssetType>> = {
  STOCKS: 'STOCK',
  FIXED_DEPOSIT: 'FIXED_DEPOSIT',
  MUTUAL_FUND: 'MUTUAL_FUND',
  CRYPTO: 'CRYPTO',
  GOLD: 'GOLD',
  NPS: 'NPS',
  EPF: 'EPF',
  PPF: 'PPF',
};

export const getPortfolioAssetTypeForAccountType = (accountType: Account['type']): PortfolioAssetType =>
  ACCOUNT_ASSET_TYPE[accountType] ?? 'STOCK';

export const getDefaultPortfolioAssetName = (account: Account) => {
  if (account.type === 'STOCKS') {
    return '';
  }
  return account.name;
};
